<app-stages [stages]="stages" currentStage="Aktualny adres zamieszkania">
</app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)='submitAndGoNext()'>
    <fieldset>
      <legend>
        Mój adres
      </legend>
      <br>
      <div class="row">
        <div class="col-12">
          <div class='form-group' *ngIf='"changeCurrentAddress" as controlName'>
            <div class='custom-checkbox custom-inline' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
              <input
                #input
                (change)="form.changeCurrentAddressChange(input.checked)"
                [formControlName]='controlName'
                type='checkbox'
                [id]='controlName'
                [name]='controlName'>
              <label [for]='controlName'>
                Dane adresowe uległy zmianie
              </label>
            </div>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
      <div class="row">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"changeCurrentAddressCity" as controlName'>
            <label [for]='controlName'>
              Miejscowość *
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu miejscowość'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"changeCurrentAddressStreet" as controlName'>
            <label [for]='controlName'>
              Ulica
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu nazwę ulicy'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
      <div class="row">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"changeCurrentAddressPostalCode" as controlName'>
            <label [for]='controlName'>
              Kod pocztowy *
            </label>
            <input
              [id]='controlName'
              mask='00-000'
              [dropSpecialCharacters]='false'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu kod pocztowy'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-2'>
          <div class='form-group' *ngIf='"changeCurrentAddressHouseNumber" as controlName'>
            <label [for]='controlName'>
              Nr domu *
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu nr domu'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-2'>
          <div class='form-group' *ngIf='"changeCurrentAddressApartmentNumber" as controlName'>
            <label [for]='controlName'>
              Nr mieszkania
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu nr mieszkania'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <fieldset>
      <legend>
        Adres współwłaściciela <small>(Jeśli dotyczy)</small>
      </legend>
      <br>
      <div class="row">
        <div class="col-12">
          <div class='form-group' *ngIf='"changeCurrentAddressCoOwner" as controlName'>
            <div class='custom-checkbox custom-inline' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
              <input
                #input
                (change)="form.changeCurrentAddressCoOwnerChange(input.checked)"
                [formControlName]='controlName'
                type='checkbox'
                [id]='controlName'
                [name]='controlName'>
              <label [for]='controlName'>
                Dane adresowe uległy zmianie
              </label>
            </div>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class="col-12">
          <div class='form-group' *ngIf='"changeCurrentAddressCoOwnerData" as controlName'>
            <label [for]='controlName'>
              Adres *
            </label>
            <textarea
              rows="4"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu aktualny adres zamieszkania współwłaściciela'>
            </textarea>
            <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <div class='application-actions'>
      <button
        routerLink="../dane-identyfikacyjne"
        type='button'
        class='btn btn-secondary'>
        <span>
          Wstecz
        </span>
      </button>
      <button
        class='btn btn-primary'
        type="submit">
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
